import axios from "axios";
import commonLib from "../control/commonLib";
import konsole from "../control/Konsole";
import { $Service_Url } from "./UrlPath";
import { LeadStackerToken1 } from "../control/Constant";
import { encryptPayload, decryptPayload } from "../crypto/aesGcm";

const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION_ENABLED;

function showErrorModal() {
    if (typeof document === "undefined") return;

    if (document.getElementById("global-error-overlay")) return;

    if (!document.getElementById("global-error-modal-styles")) {
        const style = document.createElement("style");
        style.id = "global-error-modal-styles";
        style.textContent = `
            #global-error-overlay {
                position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                background-color: rgba(0,0,0,0.5);
                backdrop-filter: blur(2px);
                display: flex; align-items: center; justify-content: center;
                z-index: 9999;
                animation: geoFadeIn 0.15s ease-out;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            }
            #global-error-modal {
                background: #fff; border-radius: 16px;
                box-shadow: 0 20px 60px rgba(0,0,0,0.2);
                max-width: 400px; width: 90%; margin: 0 20px;
                position: relative; padding: 24px 28px;
                text-align: center;
                animation: geoSlideUp 0.2s ease-out;
            }
            #global-error-close {
                position: absolute; top: 14px; right: 14px;
                width: 28px; height: 28px; border-radius: 50%;
                border: none; background: transparent; cursor: pointer;
                display: flex; align-items: center; justify-content: center;
                color: #9CA3AF; font-size: 18px; line-height: 1;
                transition: background 0.15s;
            }
            #global-error-close:hover { background: #F3F4F6; color: #4B5563; }
            #global-error-icon {
                width: 52px; height: 52px; border-radius: 50%;
                background: #FEF2F2; display: flex; align-items: center;
                justify-content: center; margin: 0 auto 16px;
            }
            #global-error-modal h2 {
                font-size: 18px; font-weight: 600; color: #111827;
                margin: 0 0 8px 0; line-height: 1.4;
            }
            #global-error-modal p {
                font-size: 14px; color: #6B7280; margin: 0 0 20px 0; line-height: 1.5;
            }
            #global-error-btn {
                background: #DC2626; color: #fff; border: none;
                border-radius: 8px; padding: 10px 20px;
                font-size: 14px; font-weight: 500; cursor: pointer;
                transition: background 0.15s;
            }
            #global-error-btn:hover { background: #B91C1C; }
            @keyframes geoFadeIn { from { opacity: 0; } to { opacity: 1; } }
            @keyframes geoSlideUp {
                from { transform: translateY(12px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
            }
        `;
        document.head.appendChild(style);
    }

    const overlay = document.createElement("div");
    overlay.id = "global-error-overlay";
    overlay.innerHTML = `
        <div id="global-error-modal">
           
            <div id="global-error-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
            </div>
            <h2>Site is under maintenance</h2>
            <p>Thank you for your patience</p>
        </div>
    `;

    document.body.appendChild(overlay);
}


export let $CommonServiceFn = {

    InvokeCommonApi: async function (method, url, inputdata, callback) {
        let token = commonLib.getSessionStorage("AuthToken") || "";
        let requestData = inputdata;

        // ENCRYPTION - ONLY HERE
        if (method.toUpperCase() === "POST" || method.toUpperCase() === "PUT" || method.toUpperCase() === "PATCH") {
            requestData = isEncryptionEnabled === "true" ? await encryptPayload(inputdata) : inputdata;
        }

        axios({
            headers: { 'Access-Control-Allow-Origin': true, "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
            method: method,
            url: url,
            data: requestData
        })
            .then(async data => {
                if (callback) {

                    // RESPONSE DECRYPTION
                    if (data?.data?.encrypted === true && isEncryptionEnabled === "true") {
                        data.data = await decryptPayload(data.data);
                    }
                    callback(data, null);
                }
            }).catch(error => {

                let errordata = null;

                if (error.response) {
                    errordata = error.response;
                    if (errordata.status == 401) {
                        sessionStorage.setItem("AuthToken", "");
                    }

                    if (errordata.status !== 401 && errordata.status == 404) {
                        if (callback) {
                            return callback(null, errordata);
                        }
                    }

                    if (errordata.status !== 401 && errordata.status == 400) {
                        if (callback) {
                            return callback(null, errordata);
                        }
                    }

                    if (errordata.status !== 401 && errordata.status == 503) {
                        konsole.log("Something went Wrong. Try again later.");
                    }

                    // ERROR MODAL
                    if (errordata.status !== 401 && errordata.status !== 404 &&
                        errordata.status !== 400 && (
                            errordata.status == 503 ||
                            (
                                errordata.status >= 402 &&
                                errordata.status <= 500
                            )
                        )
                    ) {
                        showErrorModal(errordata, url);
                    }

                    if (callback) {
                        return callback(null, errordata);
                    }
                }
            });
    },


    InvokeCommonApi2: function (method, url, inputdata, callback) {

        axios.defaults.headers.common['Authorization'] =
            `Bearer ${LeadStackerToken1}`;

        axios({
            config: {
                headers: {
                    'Content-Type': 'application/json'
                }
            },
            method: method,
            url: url,
            data: inputdata
        })
            .then(data => {
                if (callback) {
                    konsole.log("URL-", url, data);
                    callback(data, null);
                }
            })
            .catch(error => {

                let errordata = null;

                konsole.log("Error ", error + url);
                konsole.log("Error ", error.response);

                if (error.response) {
                    errordata = error.response;

                    if (errordata.status == 401) {
                        sessionStorage.setItem("AuthToken", "");
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 404
                    ) {
                        if (callback) {
                            return callback(null, errordata);
                        }
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 400
                    ) {
                        if (callback) {
                            return callback(null, errordata);
                        }
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 503
                    ) {
                        konsole.log("Something went Wrong. Try again later.");
                    }

                    // ERROR MODAL
                    if (
                        errordata.status !== 401 &&
                        errordata.status !== 404 &&
                        errordata.status !== 400 &&
                        (
                            errordata.status == 503 ||
                            (
                                errordata.status >= 402 &&
                                errordata.status <= 500
                            )
                        )
                    ) {
                        showErrorModal(errordata, url);
                    }

                    if (callback) {
                        return callback(null, errordata);
                    }
                }
            });
    },


    InvokeCommonMultpartApi: function (method, url, inputdata, callback) {

        konsole.log("Req url " + url);

        axios({
            headers: {
                crossDomain: true
            },
            config: {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    crossDomain: true
                }
            },
            method: method,
            url: url,
            data: inputdata
        })
            .then(data => {
                if (callback) {
                    konsole.log("URL-", url, data);
                    callback(data, null);
                }
            })
            .catch(error => {

                let errordata = null;

                konsole.log("Error ", error + url);
                konsole.log("Error ", error.response);

                if (error.response) {
                    errordata = error.response;

                    if (errordata.status == 401) {
                        // sessionStorage.setItem("AuthToken", "");
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 404
                    ) {
                        if (callback) {
                            callback(null, errordata);
                        }
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 400
                    ) {
                        if (callback) {
                            callback(null, errordata);
                        }
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 503
                    ) {
                        konsole.log("Something went Wrong. Try again later.");
                    }

                    // ERROR MODAL
                    if (
                        errordata.status !== 401 &&
                        errordata.status !== 404 &&
                        errordata.status !== 400 &&
                        (
                            errordata.status == 503 ||
                            (
                                errordata.status >= 402 &&
                                errordata.status <= 500
                            )
                        )
                    ) {
                        showErrorModal(errordata, url);
                    }

                    if (callback) {
                        callback(null, errordata);
                    }
                }
            });
    },


    InvokeCommonApiForLeadStack: function (jsonObj, callback) {

        let token = '6606a0c3-2cbf-4a3a-b12d-484c15559f61';
        let method = 'POST';
        let url = 'https://rest.gohighlevel.com/v1/contacts/';

        axios({
            headers: {
                'Access-Control-Allow-Origin': true,
                "Authorization": `Bearer ${token}`
            },
            config: {
                headers: {
                    'Content-Type': 'application/json'
                }
            },
            method: method,
            url: url,
            data: jsonObj
        })
            .then(data => {
                if (callback) {
                    konsole.log("URL-", url, data);
                    callback(data, null);
                }
            })
            .catch(error => {

                let errordata = null;

                konsole.log("Error ", error + url);
                konsole.log("Error ", error.response);

                if (error.response) {
                    errordata = error.response;

                    if (
                        (errordata.status == 400 ||
                            errordata.status == 404) &&
                        callback
                    ) {
                        return callback(null, errordata);
                    }

                    if (
                        errordata.status !== 401 &&
                        errordata.status == 503
                    ) {
                        konsole.log("Something went Wrong. Try again later.");
                    }

                    // ERROR MODAL
                    if (
                        errordata.status !== 401 &&
                        errordata.status !== 404 &&
                        errordata.status !== 400 &&
                        (
                            errordata.status == 503 ||
                            (
                                errordata.status >= 402 &&
                                errordata.status <= 500
                            )
                        )
                    ) {
                        showErrorModal(errordata, url);
                    }

                    if (callback) {
                        return callback(null, errordata);
                    }
                }
            });
    }

};